export default __webpack_public_path__ + "static/tag-dont-1-light-cac254f093847d764aee5423dc0cd9c716b7ca9daf61168c4aa78629185b66a2.png";